/**
 * @desc 通用modal组件
 * @author huachuang
 */
import React, { useEffect, useState, useImperativeHandle } from 'react';
import { Modal, Spin, Space, Button } from 'antd';

// interface RealModalProps {
//   onCancel: () => void;
//   onOk: (setSpinning?: React.Dispatch<React.SetStateAction<boolean>>) => void;
//   title: string;
//   visible: boolean;
//   wrapperClassName?: string;
//   width?: number;
//   needValidate?: boolean;
//   children?: React.ReactNode;
//   footer?: React.ReactNode | null | undefined;
// }

// export interface RealModalInstance {
//   setSpinning: (spinning: boolean) => void;
// }

const RealModal = (
  props,
  ref,
) => {
  const {
    onCancel,
    onOk,
    title,
    visible,
    children,
    wrapperClassName,
    width,
    centered,
    needValidate,
    footer,
  } = props;
  const [spinning, setSpinning] = useState(false);
  const wrapperCls = wrapperClassName
    ? `real-modal-wrapper ${wrapperClassName}`
    : 'real-modal-wrapper';

  const setSpinningHandle = (spinning) => {
    setSpinning(spinning);
  };

  useEffect(() => {
    if (!visible && spinning) {
      setSpinning(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  /**
   * 向外暴露的实例方法
   */
  useImperativeHandle(ref, () => {
    return {
      setSpinning: setSpinningHandle,
    };
  });

  return (
    <Modal
      title={title}
      open={visible}
      footer={null}
      wrapClassName={wrapperCls}
      width={width}
      centered={centered}
      destroyOnClose={true}
      maskClosable={false}
      onCancel={() => {
        setSpinning(false);
        onCancel();
      }}
    >
      <Spin spinning={spinning}>
        <div className="modal-content">
          {children}
          {footer === undefined && (
            <div className="footer">
              <Space size={16}>
                <Button
                  onClick={() => {
                    onCancel();
                  }}
                  className="cancel-btn"
                >
                  取消
                </Button>
                <Button
                  className="confirm-btn"
                  onClick={() => {
                    if (needValidate) {
                      onOk(setSpinning);
                      return;
                    }
                    setSpinning(true);
                    onOk();
                  }}
                >
                  确定
                </Button>
              </Space>
            </div>
          )}
          {footer && footer}
        </div>
      </Spin>
    </Modal>
  );
};

export default React.forwardRef(RealModal);
